import React from "react"
import AppointmentDetail from "../components/AppointmentDetail"

const AppointmentDetailScreen = (props) => {
  return (
      <AppointmentDetail {...props} />
  )
}
export default AppointmentDetailScreen
